module.exports = __webpack_public_path__ + "media/images/warsaw_coffee_tour_cream-327471e5cee7caf4ca178f2ae8ee8d66.png";